<template>
  <v-container>
    <h2>{{ $t('settings.title') }}</h2>
      <v-subheader>{{ $t('settings.language') }}</v-subheader>
      <v-select v-model="$i18n.locale"
        :items="items"
        outlined>
      </v-select>
    <v-subheader>{{ $t('settings.cache') }}</v-subheader>
<v-btn :loading="working" dark color="teal darken-2" @click="clearCache()"><v-icon class="mr-2">mdi-cogs</v-icon>{{ $t('settings.cleanCache') }}</v-btn>
  </v-container>

</template>
<script>
export default {

  data: () => ({
    working: false,
    locale:'',
    items: [{text: 'français', value:'fr'}, {text: 'English', value: 'en'}],
  }),
  watch: {
    locale: function() {
      //console.log(v);
    }
  },
  methods: {
    clearCache() {
      this.working = true;
      window.location.reload(true)
    }
  }
}
</script>
